export const elTemplates: Map<string, string> = new Map()

// window.elTemplate = elTemplates
export function hydrateWidget(el: HTMLElement) {
  // const hydrateLabel = `hydrateWidget ${el.tagName}`
  // console.time(hydrateLabel)
  if (!el.firstElementChild) {
    let templateHtml = findTemplateFor(el)
    if (templateHtml) {
      el.innerHTML = templateHtml
    }
  } else if (
    el.getAttribute('x-slotted') === '[]' &&
    el.firstElementChild.tagName === 'TEMPLATE' &&
    el.firstElementChild.attributes.length === 0
  ) {
    let templateHtml = findTemplateFor(el)
    if (templateHtml) {
      el.innerHTML = templateHtml
    } else {
      // this is the prototype
      const templateHtml = el.firstElementChild.innerHTML
      elTemplates.set(el.tagName, templateHtml)
      el.innerHTML = templateHtml
    }
  } else if (el.firstElementChild?.tagName === 'TEMPLATE' && el.firstElementChild.attributes.length === 0) {
    const templateHtml = el.firstElementChild.innerHTML
    el.innerHTML = templateHtml
  }
  // console.timeEnd(hydrateLabel)
}

export function findTemplateFor(el: HTMLElement): string | null {
  const tagName = el.tagName
  if (elTemplates.has(tagName)) {
    return elTemplates.get(tagName)!
  }

  let protoEl = _findTemplate(el.tagName)
  if (protoEl) {
    const protoHtml = protoEl.innerHTML
    elTemplates.set(tagName, protoHtml)
    return protoHtml
  }

  return null
}

function _findTemplate(tagName: string, root: ParentNode = document.body): HTMLElement | null {
  const candidateEls = root.querySelectorAll(tagName)
  for (let i = 0, len = candidateEls.length; i < len; i++) {
    let el = candidateEls.item(i)
    if (el.getAttribute('x-slotted') === '[]' && el.firstElementChild) {
      return el.firstElementChild as HTMLElement
    }
  }

  const templateEls = root.querySelectorAll('template')
  for (let i = 0, len = templateEls.length; i < len; i++) {
    const templateEl = templateEls.item(i)
    const el = _findTemplate(tagName, templateEl.content)
    if (el) {
      return el
    }
  }

  return null
}
